import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

export function SortNumbers({ onScore }) {
  const [nums, setNums] = useState([]);
  const [sel, setSel] = useState(-1);
  const [moves, setMoves] = useState(0);
  const [time, setTime] = useState(0);
  const [running, setRunning] = useState(false);
  const [won, setWon] = useState(false);
  const reported = useRef(false);

  useEffect(() => { if (!running) return; const id = setInterval(() => setTime((t) => t + 1), 1000); return () => clearInterval(id); }, [running]);

  const start = () => {
    const a = [...Array(9).keys()].map((i) => i + 1).sort(() => Math.random() - 0.5);
    setNums(a); setSel(-1); setMoves(0); setTime(0); setRunning(true); setWon(false); reported.current = false;
  };

  const tap = (i) => {
    if (!running) return;
    if (sel === -1) { setSel(i); return; }
    if (sel === i) { setSel(-1); return; }
    const a = [...nums]; [a[sel], a[i]] = [a[i], a[sel]];
    setNums(a); setSel(-1); setMoves((m) => m + 1);
    if (a.every((v, idx) => v === idx + 1)) { setRunning(false); setWon(true); }
  };

  useEffect(() => { if (won && !reported.current) { reported.current = true; onScore?.(Math.max(100, 1500 - moves * 40 - time * 10)); } }, [won, moves, time, onScore]);

  return (
    <div className="flex flex-col items-center" data-testid="sort-numbers">
      <div className="flex gap-6 mb-4 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="sort-moves">SWAPS: {moves}</span>
        <span className="text-neon-yellow">⏱ {time}s</span>
      </div>
      <div className="relative grid grid-cols-3 gap-2 p-2 bg-zinc-900 border-2 border-zinc-700 rounded-xl" style={{ width: "min(86vw, 300px)" }}>
        {nums.map((v, i) => (
          <button key={i} onClick={() => tap(i)} data-testid={`sort-tile-${i}`}
            className="aspect-square rounded-lg font-display font-black text-2xl transition-all"
            style={{ background: sel === i ? "#FF003C" : v === i + 1 ? "#0a3a1a" : "#27272a", color: v === i + 1 ? "#39FF14" : "#fff", transform: sel === i ? "scale(0.94)" : "scale(1)" }}>
            {v}
          </button>
        ))}
        {!running && (
          <div className="absolute inset-0 bg-black/85 rounded-xl flex flex-col items-center justify-center gap-3">
            {won && <p className="font-display font-black text-2xl text-neon-lime uppercase" data-testid="sort-won">Sorted! {moves} swaps</p>}
            <Button onClick={start} data-testid="sort-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase">
              <Play className="w-4 h-4 mr-1 fill-black" /> {won ? "Play Again" : "Start"}
            </Button>
          </div>
        )}
      </div>
      <p className="text-zinc-500 text-xs font-mono mt-3">Tap two tiles to swap them. Arrange 1–9 in order!</p>
    </div>
  );
}
